import { MarketplaceCartSchema } from "@redotech/redo-model/recommerce/marketplace-cart";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const addToCart = unaryRpc({
  name: "addToCart" as const,
  input: z.object({
    productId: zExt.objectId(),
    variantId: zExt.objectId(),
    quantity: z.number().int().positive(),
  }),
  output: z.object({ cart: MarketplaceCartSchema }),
});
